import assign from 'lodash/assign';
import Constants from '../constants';

const initState = () => ({
  addressList: [],
});

const autocompleteAddress = (state = initState(), action = {}) => {
  const { type, payload } = action;

  switch (type) {
    case Constants.SET_AUTO_COMPLETE_ADDRESS_LIST:
      return assign({}, state, {
        addressList: payload.addressList,
      });
    default:
      return state;
  }
};
export default autocompleteAddress;
